module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "products-list-container "
  }, [_c('h1', {
    staticClass: "products-list-title"
  }, [_vm._v("产品列表")]), _vm._v(" "), _c('ul', {
    staticClass: "products-type-list"
  }), _vm._v(" "), _c('div', {
    ref: "productsList",
    staticClass: "products-list"
  }, [_c('el-row', {
    staticClass: "products-list__row",
    attrs: {
      "gutter": 24
    }
  }, _vm._l((_vm.productListData), function(item) {
    return _c('el-col', {
      key: item.productId,
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "products-list-item",
      attrs: {
        "tag": "div"
      },
      on: {
        "click": function($event) {
          return _vm.beginApplyLoan(item)
        }
      }
    }, [_c('div', {
      staticClass: "products-list-item__pic",
      style: ({
        backgroundImage: ("url(" + _vm.imgSrcPrefix + (item.productImg) + ")")
      })
    }, [_c('div', {
      staticClass: "products-list-item__pic-warp"
    })]), _vm._v(" "), (item.productClassification == 1) ? _c('div', {
      staticClass: "products-list-item__interest-rate"
    }, [_c('p', [_vm._v("仅对长期合作客户开放")]), _vm._v(" "), _c('p', [_vm._v("折扣利率、资料简化")]), _vm._v(" "), _c('p', [_vm._v("融资比例上限提高")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 2) ? _c('div', {
      staticClass: "products-list-item__interest-rate"
    }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("企业应收转让")]), _vm._v(" "), _c('p', [_vm._v("融资速度快")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 3) ? _c('div', {
      staticClass: "products-list-item__interest-rate"
    }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("买方确权应付")]), _vm._v(" "), _c('p', [_vm._v("利率相对优惠")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 4) ? _c('div', {
      staticClass: "products-list-item__interest-rate"
    }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("仅对战略合作买方体系开放")]), _vm._v(" "), _c('p', [_vm._v("解决立账期间短时资金需求")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 5) ? _c('div', {
      staticClass: "products-list-item__interest-rate"
    }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("提供票据融资咨询服务")]), _vm._v(" "), _c('p', [_vm._v("多方合作、渠道无忧")])]) : _vm._e(), _vm._v(" "), (item.productClassification == 6) ? _c('div', {
      staticClass: "products-list-item__interest-rate"
    }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("融资比例100%")]), _vm._v(" "), _c('p', [_vm._v("融资成本较低")])]) : _vm._e(), _vm._v(" "), _c('div', {
      class: item.productName.length > 6 ? 'products-list-item__title2' : 'products-list-item__title'
    }, [_vm._v(_vm._s(item.productName))])])])
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "loading"
  }, [_vm._v("\n                正在加载...\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComplete),
      expression: "isComplete"
    }],
    staticClass: "noMoreData"
  }, [_vm._v("\n                没有更多数据了\n            ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21596d8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Products.vue
// module id = 1060
// module chunks = 1